var map = {
	"./Create_a_clean_16-bit_SNES-style_pixel_art_charact_custom-Teleport disappear_east.gif": 2287,
	"./Create_a_clean_16-bit_SNES-style_pixel_art_charact_custom-Teleport disappear_south.gif": 6483
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5197;